import React from 'react';
import './Login.css';

import {
    Nav,
    NavDropdown,
} from 'react-bootstrap';



function Login(props) {
    if (props.isAuthenticated) {
        return (
            <Nav className="m-auto login">
                <NavDropdown id="navDropdownBar" className="loginLink" drop="up" style={{ fontSize: `130%`, color: 'green' }} title={<div style={{display: "inline-block", color:"white"}}><div><i className="far fa-user-circle rounded-circle align-self-center mr-2 avatar"></i></div>{props.user}</div>}>
                    <NavDropdown.Item id="navDropdownItem" className="loginLink" onClick={props.authButtonMethod}>Logg ut</NavDropdown.Item>
                </NavDropdown>
            </Nav>
        );
    }
    // Not authenticated, return a sign in link
    return (
        <Nav className="m-auto login">
            <Nav.Item>
                <Nav.Link className="loginLink" onClick={props.authButtonMethod}>Logg inn</Nav.Link>
            </Nav.Item>
        </Nav>
    );
}

export default Login;